function App() {
  return (
      // eslint-disable-next-line react/style-prop-object
      <div className="App">
          <h1>From Hotfix to Main and Develop</h1>
          <h2>Hotfix - testing 1</h2>
          <h1>Again...</h1>


      </div>
  );
}

export default App;

